import axios from "axios";

export default class Service {
    constructor() {
        this.url = "/api/Day/";
    }

    getClientCitations() {
        return axios.get(this.url + "GetClientCitations");
    }

    getDaysResults(startDate, endDate) {
        return axios.get(this.url + "GetClientDaysResults", { params: { startDate, endDate } });
    }

    upsertDayResult(dayResult) {
        return axios.post(this.url + "UpsertDayResult", dayResult);
    }

    getDaysTasks(startDate, endDate) {
        return axios.get(this.url + "GetClientDaysTasks", { params: { startDate, endDate } });
    }

    upsertDayTask(dayTask) {
        return axios.post(this.url + "UpsertDayTask", dayTask);
    }

    delegateDayTask(request) {
        return axios.post(this.url + "DelegateDayTask", request);
    }

    getActiveHabits(startDate, endDate) {
        return axios.get(this.url + "GetClientActiveHabits", { params: { startDate, endDate } });
    }

    createHabit(habit) {
        return axios.post(this.url + "CreateHabit", habit);
    }

    editHabit(habit) {
        return axios.post(this.url + "EditHabit", habit);
    }

    deleteHabit(id) {
        return axios.post(this.url + "DeleteHabit", id);
    }

    getRandomSport(options) {
        return axios.get(this.url + "GetRandomSport", { params: options });
    }

    getRandomHobby(options) {
        return axios.get(this.url + "GetRandomHobby", { params: options });
    }

    getRandomFood(options) {
        return axios.get(this.url + "GetRandomFood", { params: options });
    }

    getRandomDessert(options) {
        return axios.get(this.url + "GetRandomDessert", { params: options });
    }
}